import UnitType from '@r6digital/rapidstor-types/react/entities/UnitType';

/**
 * Builds the ordered list of unit-type "cards" for /book-unit's two-box stack.
 *
 * - No deals: a single standard-price card.
 * - One distinct deal: a standard card plus the deal card (unless hideStandardPrices
 *   suppresses the standard card).
 * - Two or more distinct deals: the first two deals, with no standard card.
 *
 * `unitType.deals` is deduplicated by `_id` first, so a duplicate deal entry can never
 * masquerade as a second, distinct deal and knock the standard card out of the stack.
 */
export function buildUnitTypeCards(unitType: UnitType, hideStandardPrices: boolean): UnitType[] {
    const uniqueDeals = unitType.deals.filter(
        (deal, index) => unitType.deals.findIndex((candidate) => candidate._id === deal._id) === index,
    );

    const cardsList: UnitType[] = [{ ...unitType, deal: undefined }];

    for (const deal of uniqueDeals) {
        cardsList.push({ ...unitType, deal });
    }

    // @feature hideStandardPrices
    // Hide standard prices if there are deals
    if (hideStandardPrices && cardsList.length > 1) {
        cardsList.splice(0, 1);
    }

    return cardsList.length > 2 ? cardsList.slice(1, 3) : cardsList;
}
